import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    homeContainer: {
        maxWidth: '1264px',
        padding: 0
    }
}));